import { useState } from "react";
import Styles from "./input.module.css";

const Input = ({
  inputType,
  placeHolderText,
  headerText,
  footerText,
  titleText,
  size,
  ...props
}) => {
  const [isHover, setIsHover] = useState(false);
  const toggleHover = () => {
    setIsHover(!isHover);
  };

  const [isFocus, setIsFocus] = useState(false);
  const toggleFocus = () => {
    setIsFocus(!isFocus);
  };

  const outlineHoverStyle = {
    border: "0.18rem solid blue",
    cursor: "default",
  };

  const outlineErrorHoverStyle = {
    border: "0.18rem solid red",
    cursor: "default",
  };

  const outlineFocusStyle = {
    border: "thick double blue",
    cursor: "default",
  };

  const outlineErrorFocusStyle = {
    border: "thick double red",
    cursor: "default",
  };

  const errorStyle = {
    border: "0.0625rem solid #D32F2F",
  };

  const normalBtnStyle = {
    borderRadius: "0.5rem",
    border: "0.0625rem solid #828282",
  };

  const disabledStyle = {
    background: "#F2F2F2",
  };

  //Input Size
  const defaultSizeInput = {
    width: "12.5rem",
    height: "3.5rem",
  };

  const smallSizeInput = {
    width: "12.5rem",
    height: "2.5rem",
  };

  const largeSizeInput = {
    width: "15.625rem",
    height: "4rem",
  };

  const fullWidthInput = {
    width: "56.25rem",
    height: "4rem",
  };

  const multirowSizeInput = {
    width: "12.5rem",
    height: "9.375rem",
  };

  let inputStyle;
  switch (inputType) {
    case "hover":
      if (isHover) {
        inputStyle = outlineHoverStyle;
      } else {
        inputStyle = normalBtnStyle;
      }
      break;
    case "focus":
      if (isFocus) {
        inputStyle = outlineFocusStyle;
      } else {
        inputStyle = normalBtnStyle;
      }
      break;
    case "error":
      inputStyle = errorStyle;
      break;
    case "error-hover":
      if (isHover) {
        inputStyle = outlineErrorHoverStyle;
      } else {
        inputStyle = normalBtnStyle;
      }
      break;
    case "error-focus":
      if (isFocus) {
        inputStyle = outlineErrorFocusStyle;
      } else {
        inputStyle = normalBtnStyle;
      }
      break;
    case "disabled":
      inputStyle = disabledStyle;
      break;
    default:
      inputStyle = normalBtnStyle;
      break;
  }

  let inputSize;
  switch (size) {
    case "small":
      inputSize = smallSizeInput;
      break;
    case "large":
      inputSize = largeSizeInput;
      break;
    case "fullwidth":
      inputSize = fullWidthInput;
      break;
    case "multirow":
      inputSize = multirowSizeInput;
      break;
    default:
      inputSize = defaultSizeInput;
      break;
  }

  return (
    <div className={Styles.input}>
      <p className={Styles.titleText}>{titleText}</p>
      <p className={inputType === "error" ? Styles.error : Styles.headerText}>
        {headerText}
      </p>
      <input
        type="text"
        style={{ ...normalBtnStyle, ...inputSize, ...inputStyle }}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
        onFocus={toggleFocus}
        onBlur={toggleFocus}
        placeholder={placeHolderText}
      />
      <p className={Styles.footerText}>{footerText}</p>
    </div>
  );
};

export default Input;
